<template>
  <div class="flexing">
    <div class="leftcol animate__animated wow animate__slideInLeft">
     
      <div class="center">
         <h1 class="typing-demo">Jordan Dawson</h1>
      <h2 class="typing-demo">Creative Web App Developer</h2>
        <button type="button">
          <i class="bi bi-github icons"></i>
        </button>

        <button type="button">
          <i class="bi bi-linkedin icons"></i>
        </button>

        <button type="button">
          <i class="bi bi-envelope icons"></i>
        </button>
      </div>
    </div>

    <img
      src="@/assets/landing/Jords.jpeg"
      alt=""
      class="rightcol animate__animated wow animate__slideInRight"
    />
  </div>

</template>

<script>

</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  overflow: hidden;
}

.flexing {
  display: flex;
  align-items: center;
}
.icons {
  font-size: 50px;
  color: rgb(255, 255, 255);
  background-color: purple;
  border-radius: 50%;
  padding: 10px;
  margin-left: 60px;
}

.leftcol {
  background: rgb(56, 56, 56);
  height: 100vh;
  margin: 0%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 30px;
  border-right: 10px solid purple;
}
.rightcol {
  background: purple;
  max-height: 100vh;
  object-fit: cover;
}
.center {
  margin: auto !important;
}
.leftcol,
.rightcol {
  width: 50%;
}

button {
  background-color: rgba(0, 0, 0, 0) !important;
  border: rgba(0, 0, 0, 0) !important;
  padding-right: 25px;
}

.wrapper {
  height: 100vh;
  /*This part is important for centering*/
  display: flex;
  align-items: center;
  justify-content: center;
}

.typing-demo {
  width: 100%;
  animation: typing 2s steps(22), blink 0.5s step-end infinite alternate;

  white-space: nowrap;
  overflow: hidden;
  font-weight: bolder;
  color: aliceblue;
}

@keyframes typing {
  from {
    width: 0;
    color: rgba(0, 0, 0, 0);
  }
}

@keyframes blink {
  50% {
    border-color: transparent;
  }
}
@media screen and (max-width: 800px) {
  .flexing {
    flex-direction: column;
  }
  .leftcol,
  .rightcol {
    width: 100%;
  }
  h1 {
    font-size: 10vw !important;
  }
  h2 {
    font-size: 6vw !important;
  }
  i {
    font-size: 30px !important;
  }
}
</style>
